import { createContext } from "react";

import { PerformanceChartState } from "./types";

export const PerformanceChartContext = createContext<PerformanceChartState>(
  {} as PerformanceChartState,
);
